export default __webpack_public_path__ + "static/media/p3.fec43643.png";